import Hansen from "../Entries/WorkHistory/Hansen";
import SierraNevada from "../Entries/WorkHistory/SierraNevada";

export default function WorkHistory() {
  return (
    <div>
      <SierraNevada />
      <Hansen />
    </div>
  );
}